import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import {
  Box,
  Card,
  CardContent,
  Typography,
  Checkbox,
  Chip,
  Stack,
  List,
  ListItem,
  TextField,
  Button,
  MenuItem,
  Paper,
  IconButton,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';


import {
  getTodos,
  addTodo,
  editTodo,
  deleteTodo,
} from "../../actions/dataActions"

const priorityColor = {
  5: 'error',
  4: 'warning',
  3: 'secondary',
  2: 'primary',
  1: 'success',
};

const TodoList = () => {

  const dispatch = useDispatch()
  const todos = useSelector((state) => state.todos);
  const [editTask, setEditTask] = useState(null);
  const [form, setForm] = useState({
    title: '',
    description: '',
    priority: 3,
  });


  useEffect(() => {

    dispatch(getTodos())

  }, [dispatch]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddTask = () => {
    if (!form.title.trim()) return;

    const newTask = {
      title: form.title,
      description: form.description,
      priority: form.priority,
      complete: false,
    };


    dispatch(addTodo(newTask))
    setForm({ title: '', description: '', priority: 3 });
  };

  const toggleComplete = (todo) => {
    const newTodo = { ...todo, complete: !todo.complete }
    dispatch(editTodo(newTodo))

  };
  const handleDelete = (id) => {
    dispatch(deleteTodo(id))
  };
  const handleEditOpen = (task) => {
    setEditTask(task);

  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditTask((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSave = () => {
    dispatch(editTodo(editTask));
    setEditTask(null);
  };

  return (
    <>

      <Box sx={{ flexGrow: 1, px: 2, pt: 4, m: 10, height: '70vh', }}>
        <Typography variant="h4" gutterBottom>
          Todo List
        </Typography>
        <Grid container spacing={2} sx={{ height: '100%' }}>
          {/* Left column: Add Task Form */}
          <Grid size={{ xs: 12, md: 5 }} sx={{ height: '100%', pr: 2.5, pl: 2.5 }}>
            {/* Add Task Form */}
            <Paper sx={{ p: 2, mb: 4 }}>
              <Typography variant="h6" gutterBottom>
                Add New Task
              </Typography>
              <Stack spacing={2}>
                <TextField
                  label="Title"
                  name="title"
                  fullWidth
                  value={form?.title || ""}
                  onChange={handleInputChange}
                />
                <TextField
                  label="Description"
                  name="description"
                  fullWidth
                  multiline
                  rows={2}
                  value={form?.description || ""}
                  onChange={handleInputChange}
                />
                <TextField
                  label="Priority"
                  name="priority"
                  select
                  fullWidth
                  value={form?.priority || 3}
                  onChange={handleInputChange}
                >
                  <MenuItem value={5}>Very High</MenuItem>
                  <MenuItem value={4}>High</MenuItem>
                  <MenuItem value={3}>Medium</MenuItem>
                  <MenuItem value={2}>Low</MenuItem>
                  <MenuItem value={1}>Very Low</MenuItem>
                </TextField>
                <Button variant="contained" onClick={handleAddTask}>
                  Add Task
                </Button>
              </Stack>
            </Paper>

          </Grid>

          {/* Right column: Task List */}
          <Grid size={{ xs: 12, md: 7 }} sx={{ height: '100%', pr: 2.5, pl: 2.5 }}>
            {/* Task List */}
            <List dense sx={{ p: 2, height: '100%', overflow: 'auto' }}>
              {todos.data.map((task) => (
                <ListItem key={task.id} sx={{ mb: 1, py: 0.2 }}>
                  <Card sx={{ width: '100%', p: 0.2 }}>
                    <CardContent sx={{ p: 1 }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Stack direction="row" alignItems="center" spacing={0.5}>

                          <Checkbox
                            checked={task.complete}
                            onChange={() => toggleComplete(task)}
                          />

                          <Typography
                            variant="h6"
                            sx={{
                              textDecoration: task.complete ? 'line-through' : 'none',
                            }}
                          >
                            {task.title}
                          </Typography>
                        </Stack>
                        <Stack direction="row">


                          <Chip label={task.priority} color={priorityColor[task.priority]}
                          />
                          <IconButton
                            onClick={() => handleEditOpen(task)}
                            size="small">
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => handleDelete(task.id)}
                            size="small">
                            <DeleteIcon />
                          </IconButton>
                        </Stack>

                      </Stack>

                      <Typography variant="body2" color="text.secondary" mt={1}>
                        {task.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
        {/* Edit Task Dialog */}
        <Dialog open={!!editTask} onClose={() => setEditTask(null)} fullWidth>
          <DialogTitle>Edit Task</DialogTitle>
          <DialogContent>
            <Stack spacing={2} mt={1}>
              <TextField
                label="Title"
                name="title"
                fullWidth
                value={editTask?.title || ''}
                onChange={handleEditChange}
              />
              <TextField
                label="Description"
                name="description"
                fullWidth
                multiline
                rows={2}
                value={editTask?.description || ''}
                onChange={handleEditChange}
              />
              <TextField
                label="Priority"
                name="priority"
                select
                fullWidth
                value={editTask?.priority || 3}
                onChange={handleEditChange}
              >
                <MenuItem value={5}>Very High</MenuItem>
                <MenuItem value={4}>High</MenuItem>
                <MenuItem value={3}>Medium</MenuItem>
                <MenuItem value={2}>Low</MenuItem>
                <MenuItem value={1}>Very Low</MenuItem>
              </TextField>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditTask(null)}>Cancel</Button>
            <Button onClick={handleEditSave} variant="contained">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default TodoList;
